var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin)?_c('div',{staticClass:"timeline-stepper"},[_c('button',{on:{"click":_vm.decrementStep}},[_vm._v("–")]),_c('button',{on:{"click":_vm.incrementStep}},[_vm._v("+")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }